import { DatePipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { MyserviceService } from "../myservice.service";
import * as moment from "moment";
import { environment } from "src/environments/environment";
import { MessageService } from "primeng/api";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Router } from "@angular/router";

@Component({
  selector: "app-document-stats",
  templateUrl: "./document-stats.component.html",
  styleUrls: ["./document-stats.component.scss"],
  providers: [MessageService]
})

export class DocumentStatsComponent implements OnInit {
  alwaysShowCalendars: boolean;
  ranges: any = {
    'Today': [moment().startOf('day'), moment().endOf('day')],
    'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
    'Last 7 Days': [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
    'Last 30 Days': [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')],
    'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day')],
    'Last Month': [
      moment().subtract(1, 'month').startOf('month').startOf('day'),
      moment().subtract(1, 'month').endOf('month').endOf('day')
    ]
  };
  isDateDisabled: boolean = false;
  selected: any;
  loader: boolean;
  headers = new HttpHeaders();
  dashboard: any = {};
  data: any = {};
  options: any = {};
  displayChart: boolean = false;
  transactionArray: any[];
  warehousesArray: any[];
  directionArray = [{ label: "Select", value: "-1" }, { label: "Inbound", value: "Inbound" }, { label: "Outbound", value: "Outbound" }]
  statusArray: any[];
  ackStatusArray: any[];
  parentWarehousesArray: any[];
  partnerArray: any[] = [];
  searchData: any = [];
  webform_reports: boolean;
  partnerLookupData: any[] = [];
reportsLookup: any[] =[
  {label: "Select", value: ""},
  {label: "Webform Report", value: "webformsReport"},
]

  constructor(public localstorage: LocalStorageService, private messageService: MessageService,
    public session: SessionStorageService,
    private http: HttpClient,
    public datepipe: DatePipe,
    private service: MyserviceService,
    private router: Router) {
    this.headers = this.headers.append(
      "authorization",
      this.localstorage.retrieve("token"))
  }

  ngOnInit() {
    this.getDropdownOptions();
    this.setToDefault();
    console.log('this.router.url ', this.router.url);
    
    if(this.router.url === '/mscvp/webforms-reports') {
      this.webform_reports = true;
      this.getPartnersLookup();
    } else {
      this.webform_reports = false;
    }
  }
 
  getPartnersLookup() {
    this.service.getPartnersLookup().subscribe((res: any) => {
      this.partnerLookupData = res;    
      this.partnerLookupData.unshift({ TC_PartnerName: "Select", value: "" });
    })
  }
  generateExcel() {
    console.log(this.dashboard);
    
    const body = {
        "partnerId": this.dashboard.partnerNames.TC_PARTNER_ISA_ID,
        "fromDate": this.datepipe.transform(this.selected.startDate, "MM/dd/yyyy HH:mm"),
        "toDate":this.datepipe.transform(this.selected.endDate, "MM/dd/yyyy HH:mm")
    };
    const reportType: any = this.dashboard.reportList ? this.dashboard.reportList.value : '';
    this.service.download_Webforms_Excel(body, reportType).subscribe((res: any) => {
      console.log('res ', res);
      const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'webforms.xlsx'; // or use a dynamic name
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
  }, error => {
      console.error('Download error:', error);
  });
  }
  dbChange(flowFlag, database) {
    this.transactionArray = this.service.getDocumentTypes(
      this.localstorage.retrieve("token"),
      flowFlag,
      "LIVE"
    );
    //To get list of partners
    // this.service.getPartners(
    //     this.localstorage.retrieve("token"),
    //     flowFlag,
    //     database
    // ).subscribe((res) => {
    //     this.partnerArray = res;
    // })
    this.getTradingPartner();
    this.parentWarehousesArray = this.service.getParentWarehouses(
      this.localstorage.retrieve("token"),
      flowFlag,
      "LIVE"
    );
    this.getWarehousesForWms([],  "LIVE")
  }

  getDropdownOptions() {
    this.statusArray = this.service.getStatus();
    this.ackStatusArray = this.service.getDocStats();
  }
  getTradingPartner() {
    let headers = new HttpHeaders();
    headers = headers.append("authorization", this.localstorage.retrieve("token"));
    this.http.get(environment.apiUrl + "/utilities/tradingPartnerName", { headers: headers })
      .subscribe((response: any) => {
        if (!response || response.length === 0) {
          this.partnerArray = [];
          return;
        }       
        this.partnerArray = [
          { label: "Select", value: "-1" },
          ...response.map(item => ({
            label: item,  
            value: item 
          }))
        ];
        //console.log("Fetched Partners:", this.partnerArray);
      }, error => {
        //console.error("Error fetching partners:", error);
      });
  }
  getWarehousesForWms(parentWarehouse, database) {
    this.dashboard.warehouse = [];
    this.warehousesArray = this.service.getWarehouses(
      this.localstorage.retrieve("token"),
      "LIVE",
      this.service.multiSelectValue(this.parentWarehousesArray, parentWarehouse)
    );
  }

  generate() {
    this.displayChart = true
    this.dashboard.fromDate = this.datepipe.transform(
      this.selected.startDate,
      "MM/dd/yyyy HH:mm"
    );
    this.dashboard.toDate = this.datepipe.transform(
      this.selected.endDate,
      "MM/dd/yyyy HH:mm"
    );
    let reqBody = { ...this.dashboard };
    // let selectedPartners = []
    // this.dashboard.partnerNames.map((e) => {
    //   selectedPartners.push(e.value)
    // })
    // reqBody.partnerNames = this.service.multiSelectValue(this.partnerArray, selectedPartners);
    reqBody.parentWarehouse = this.service.multiSelectValue(this.parentWarehousesArray, reqBody.parentWarehouse);
    reqBody.warehouse = reqBody.warehouse != '' ? reqBody.warehouse : reqBody.warehouse;
    reqBody.partnerNames  = this.dashboard.partnerNames ?  this.dashboard.partnerNames.value : "-1"
    //console.log(reqBody, "reqbody============");
    let headers = new HttpHeaders();
    headers = headers.append(
      "authorization",
      this.localstorage.retrieve("token")
    );
    //console.log(reqBody, "====req");
    this.http
      .post(
        environment.apiUrl + "/documentRepository/searchByStats", { ...reqBody },
        {
          headers: headers,
        }
      )
      .subscribe((data: any) => {
        //console.table(data);
        this.loader = false;
        this.searchData = data;
        this.searchData.forEach(element => {
          element.direction = element.direction === null || element.direction === undefined ? 'N/A' :
            element.direction
        });
        if (this.searchData.length != 0) {
          this.getPieChart();
        }
        else {
          this.displayChart = false
          this.searchData = []
          this.messageService.add({
            severity: "error",
            summary: "No Records Found",
            detail: "Data Not Available",
          });
        }
      });
  }

  setToDefault() {
    let today = new Date(); // this.service.getDateByTZ();
    this.selected = {
      startDate: new Date(
        today.getUTCFullYear() || new Date().getUTCFullYear(),
        today.getUTCMonth() || new Date().getUTCMonth(),
        today.getUTCDate() || new Date().getUTCDate(),
        0,
        0,
        0
      ),
      endDate: new Date(
        today.getUTCFullYear() || new Date().getUTCFullYear(),
        today.getUTCMonth() || new Date().getUTCMonth(),
        today.getUTCDate() || new Date().getUTCDate(),
        23,
        59,
        0
      ),
    };
    this.dbChange("M",  "LIVE");
    this.displayChart = false;
    this.dashboard.partnerNames = "-1";
    this.dashboard.parentWarehouse = [];
    this.dashboard.ackStatus = "-1";
    this.dashboard.warehouse = [];
    this.dashboard.status = "-1";
    this.dashboard.docType = [];
    this.dashboard.direction = "-1";
  }

  getPieChart() {
    // Function to generate random colors dynamically
    const generateRandomColor = () => {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    };
    let colors = this.searchData.map(() => generateRandomColor());
    let totalCount = this.searchData.reduce((acc, item) => acc + item.count, 0);
    this.data = {
      labels: this.searchData.map(item => `${item.partnerName} - ${item.transactionType}`), 
      datasets: [
        {
          data: this.searchData.map(item => item.count), 
          backgroundColor: colors, 
        }
      ]
    };

    this.options = {
      responsive: false, 
        maintainAspectRatio: true, 
        width: 800, 
        height: 800,
      tooltips: {
        callbacks: {
          label: (tooltipItem, data) => {
            let index = tooltipItem.index;
            let item = this.searchData[index]; // Get corresponding data item
            let percentage = ((item.count / totalCount) * 100).toFixed(2);

            return `Partner: ${item.partnerName} | Count: ${item.count} | DocType: ${item.transactionType} | Warehouse: ${item.parentWarehouse} | ${percentage}%`;
          }
        }
      },
      legend: {
        labels: {
          fontSize: 14,
          fontColor: 'black',
          usePointStyle: false,
          generateLabels: (chart) => {
            if (!this.searchData || this.searchData.length === 0) {
              return [];
          }
            return chart.data.labels.map((label, index) => ({              
              text: `${label} (${this.searchData[index].count || 0})`,
              fillStyle: chart.data.datasets[0].backgroundColor[index], 
              strokeStyle: chart.data.datasets[0].backgroundColor[index], 
              hidden: chart.getDatasetMeta(0).data[index].hidden || false, 
              lineWidth: 2, 
              index: index
              
            }));
          }
        }
      }
    };
}

downloadPdf(id: any) {
  const chartElement = document.getElementById(id); 
  if (!chartElement) {
      //console.error("Chart element not found!");
      return;
  }
  html2canvas(chartElement).then(canvas => {
      const imgData = canvas.toDataURL('image/png'); 
      const pdf = new jsPDF('p', 'mm', 'a4'); 
      const imgWidth = 180; 
      const imgHeight = (canvas.height * imgWidth) / canvas.width; 
      pdf.setFontSize(16);
      pdf.text('Document Statistics', 15, 20); 
      pdf.addImage(imgData, 'PNG', 15, 30, imgWidth, imgHeight); 
      pdf.save('Document_Statistics.pdf'); 
  }).catch(error => {
      //console.error("Error generating PDF:", error);
  });
}
}
